module.exports = {"data":{"markdownRemark":{"html":"<p>Testing for Facebook's IFTTT applet.</p>","frontmatter":{"categories":["General Updates"],"date":"June 07, 2017","featuredImage":"placeholder.png","title":"Barclays has fixed Windows 10 - Creators Update app issues"}}},"pathContext":{"slug":"/facebook-ifttt-test/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/post-facebook-ifttt-test.json
// module id = 408
// module chunks = 187651030027472